export const CS_AREA_ROUTE_NAMES = {
  LIST: 'cs-configuration-list',
  EDIT: 'cs-configuration-edit',
}
